import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { CardNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function Card({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<CardNode>) {
  return (
    <div
      className={`space-y-4 rounded-lg border bg-card p-4 ${node.className ?? ''}`}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
